import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import spanishTranslation from './es.json';

// The app is Spanish-only (`lng: 'es'`, no language detector/switcher). An
// English resource was dead code and had drifted to keys from another module,
// so it was removed. If English is needed later, add it together with a
// detector/switcher and a full translation pass.
export const resources = {
  es: { translation: spanishTranslation },
};

void use(initReactI18next).init({
  resources,
  lng: 'es',
  interpolation: {
    escapeValue: false,
  },
});
